/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-console,max-len,no-unused-vars */
import jApiKesiswaan from '@/services/jApiKesiswaan';
import router from '@/router';

const state = {
};

const mutations = {
};

const actions = {
  // Data Siswa ----------------------------------------------------------------------
  async getListSiswa({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.getListSiswa(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async createSiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createSiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateSiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateSiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteSiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteSiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async detailSiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.detailSiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async changePasswdSiswa({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.changePasswdSiswa(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Buku Saku Siswa ----------------------------------------------------------------------
  async getListTahunAjaran({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.listTahunAjaran(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListKelas({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.listKelas(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListKelasLulusan({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.listKelasLulusan(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListKelasAll({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.listKelasAll(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListSiswaByKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.listSiswaByKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getAdditionalInfo({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.getAdditionalInfo(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  // Prestasi & Pelanggaran ----------------------------------------------------------------------
  async createDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async detailDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.detailDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async submitDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.submitDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async approveDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.approveDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async rejectDocument({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.rejectDocument(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Ekskul ----------------------------------------------------------------------
  async createEkskul({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createEkskul(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateEkskul({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateEkskul(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteEkskul({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteEkskul(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async detailEkskul({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.detailEkskul(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getListAgenda({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.getListAgenda(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async createAgenda({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createAgenda(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateAgenda({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateAgenda(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteAgenda({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteAgenda(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getListPembina({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.getListPembina(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async createPembina({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createPembina(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePembina({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updatePembina(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePembina({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deletePembina(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getListAnggota({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.getListAnggota(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async createAnggota({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createAnggota(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateAnggota({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateAnggota(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteAnggota({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteAnggota(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getListSiswaAsync({ dispatch }, { reqData, callback }) {
    try {
      const listSiswa = await jApiKesiswaan.getListSiswa(reqData);
      const res = listSiswa.data.data;
      res.forEach((lab, index) => {
        res[index].label = lab.nama_siswa;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListSiswaAsyncNisName({ dispatch }, { reqData, callback }) {
    try {
      const listSiswa = await jApiKesiswaan.getListSiswa(reqData);
      const res = listSiswa.data.data;
      res.forEach((lab, index) => {
        res[index].label = `${lab.nis} - ${lab.nama_siswa}`;
        res[index].name = `${lab.nis} - ${lab.nama_siswa}`;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async insertAbsen({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.insertAbsen(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getListAbsen({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.listAbsen(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateAbsen({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateAbsen(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async insertNilai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.insertNilai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async getListNilai({ dispatch }, req) {
    let res;
    try {
      res = await jApiKesiswaan.listNilai(req);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateNilai({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateNilai(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Tahun Ajaran ----------------------------------------------------------------------
  async createTahunAjaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createTahunAjaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateTahunAjaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateTahunAjaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteTahunAjaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteTahunAjaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Kelas ----------------------------------------------------------------------
  async createKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Bagi Kelas ----------------------------------------------------------------------
  async createBagiKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createBagiKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateBagiKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateBagiKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteBagiKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteBagiKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Wali Kelas ----------------------------------------------------------------------
  async createWaliKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createWaliKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updateWaliKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updateWaliKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deleteWaliKelas({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deleteWaliKelas(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Poin ----------------------------------------------------------------------
  async createPoin({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createPoin(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePoin({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updatePoin(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePoin({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deletePoin(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  // Pelanggaran ----------------------------------------------------------------------
  async getListPelanggaran({ dispatch }) {
    let res;
    try {
      res = await jApiKesiswaan.listPelanggaran();
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async createPelanggaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.createPelanggaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async updatePelanggaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.updatePelanggaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },

  async deletePelanggaran({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiKesiswaan.deletePelanggaran(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      if (res.data.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.data.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.data.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.data.message, { root: true });
    }
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreKesiswaan.js